"use client";
import React, { useContext } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { ToastContext } from "@/contexts/ToastContext";

const CustomToast = () => {
//   const { show, type, message, hideToast } = useContext(ToastContext);
  const { show, type, message, } = useContext(ToastContext);


  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
      <Toast
        show={show}
        
        bg={type}
        className="text-white"
      >
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default CustomToast;
